// extracted by mini-css-extract-plugin
export default {"dropdownContainer":"Dropdowns_dropdownContainer__oo7tb","dropdownBox":"Dropdowns_dropdownBox__Jpb+M","spicialties":"Dropdowns_spicialties__UUihW"};